import { useEventCallback } from '@mui/material';
import { memo, useMemo, useState } from 'react';
import ParenthoodRelationshipList from 'shell/components/shared/parenthood-relationship-list';
import Table from 'shell/components/shared/table';
import { HeadCell } from 'shell/components/shared/table/types';
import { noop } from 'shell/utils/noop';
import { ModalChangeParenthoodVM } from '.';
import filterParenthood from 'shell/components/shared/parenthood-relationship-list/filter-parenthood';

interface FormChangeParenthoodProps {
  onChange: (values: Array<ModalChangeParenthoodVM>) => void;
  values?: Array<ModalChangeParenthoodVM>;
  isAire?: boolean;
  isOtherFamiliar?: boolean;
}

const headCells: HeadCell<ModalChangeParenthoodVM, keyof ModalChangeParenthoodVM>[] = [
  {
    id: 'fiscalCode',
    label: 'CF',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'parenthoodElement',
    label: 'Parentela',
  },
];

const FormChangeParenthoodComponent = ({
  values,
  onChange,
  isAire,
  isOtherFamiliar,
}: FormChangeParenthoodProps): React.ReactElement => {
  const [propsTable, setPropsTable] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const onChangeRelationship = useEventCallback((id: string | undefined, index: number) => {
    const newBody = values?.slice() || [];
    newBody[index].parenthoodValue = id || '';

    onChange(newBody);
  });

  const onChangePage = useEventCallback((page: number) => {
    setPropsTable({
      page,
      rowsPerPage: propsTable.rowsPerPage,
    });
  });

  const onChangeRowsPerPage = useEventCallback((rowsPerPage: number) => {
    setPropsTable({
      page: 0,
      rowsPerPage: rowsPerPage,
    });
  });

  const body: Array<ModalChangeParenthoodVM> = useMemo(() => {
    if ((values || []).length === 0) {
      return [];
    }

    // // se è un solo soggetto non minorenne
    // const isOneNotMinorenne = values?.length === 1 && !values[0].isMinorenne;

    // if (isOneNotMinorenne) {
    //   // mettere fisso non modificabile intestatario 1
    //   onChangeRelationship('1', 0);
    // }

    return values?.map((item, index) => ({
      ...item,
      parenthoodElement: (
        <ParenthoodRelationshipList
          value={item.parenthoodValue || ''}
          disabled={
            item?.isMinorenne && values?.length === 1
              ? isOtherFamiliar
                ? false
                : item?.isMinorenne && values?.length === 1
              : item?.isMinorenne && values?.length === 1
          }
          onChange={(value) => onChangeRelationship(value, index)}
          filterParenthood={filterParenthood}
          isPractice
          isHeadParenthood={
            !!values?.find((item1) => {
              if (item1.fiscalCode !== item.fiscalCode) {
                return item1.parenthoodValue?.toString() === '1';
              }
              return false;
            })
          }
          label=""
        />
      ),
    })) as Array<ModalChangeParenthoodVM>;
  }, [values, onChangeRelationship, isAire, isOtherFamiliar]);

  return (
    <>
      {body.length > 0 ? (
        <Table
          ariaLabel="Lista componenti famiglia"
          page={propsTable.page || 0}
          rowsPerPage={propsTable.rowsPerPage}
          body={body}
          count={body.length || 0}
          head={headCells}
          onSort={noop}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
          orders={{}}
          isNotLayoutFixed
          noSort
          hideButtons
        />
      ) : undefined}
    </>
  );
};

FormChangeParenthoodComponent.displayName = 'Form Change Parenthood component';

const FormChangeParenthood = memo(FormChangeParenthoodComponent);

export default FormChangeParenthood;
